import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Card,
  Drawer,
  Group,
  LoadingOverlay,
  Modal,
  ScrollArea,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import EditIcon from "@mui/icons-material/Edit";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import { CHANGE_USER_STATUS, DEL_SALES } from "apollo/mutuations";
import { GET_SALESES } from "apollo/queries";
import ActionButton from "components/controls/ActionButtonNew";
import B2bTable from "components/reusable/b2bTable";
import { SalesAddModal } from "components/Sales/SalesAddModal";
import SalesDetailModal from "components/Sales/SalesDetailModal";
import { SalesEditModal } from "components/Sales/SalesUpdateModal";
import SalesWarehouseModal from "components/Sales/salesWarehouse";
import { customLoader } from "components/utilities/loader";
import { useEffect, useState } from "react";
import { FiEye, FiUserPlus } from "react-icons/fi";
const Sales = () => {
  const [openedStatusChange, setStatusChange] = useState(false);
  const [status, setStatus] = useState(null);
  const [size, setSize] = useState("10");
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [hasMounted, setHasMounted] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  const [opened, setOpened] = useState(false);
  const [editId, setEditId] = useState();
  const [deleteID, setDeleteID] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);
  const [openedAssign, setOpenedAssign] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);

  const theme = useMantineTheme();
  const [confirmedSearch, setConfirmedSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [changeUserStatus] = useMutation(CHANGE_USER_STATUS, {
    refetchQueries: [
      {
        query: GET_SALESES,
        variables: {
          first: parseInt(size),
          page: activePage,
          search: searchValue,
          ordered_by: [
            {
              column: "CREATED_AT",
              order: "DESC",
            },
          ],
        },
      },
    ],
    onCompleted(data) {
      const action =
        data.changeUserStatus.status === "ACTIVE" ? "Activated" : "Deactivated";
      showNotification({
        color: "green",
        title: "Success",
        message: `User ${action} successfully`,
      });
      setStatusChange(false);
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to Update User",
      });
    },
  });
  const handleManualSearch = (searchTerm) => {
    setSearchValue(searchTerm);
  };
  const clearInput = () => {
    setSearchValue("");
    setConfirmedSearch("");
  };
  const { data, loading, fetchMore, refetch } = useQuery(GET_SALESES, {
    variables: {
      first: parseInt(size),
      page: activePage,
      search: searchValue,
      ordered_by: [
        {
          column: "CREATED_AT",
          order: "DESC",
        },
      ],
    },
    onError(error) {
      setOpenedDelete(false);
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to get sales ",
      });
    },
  });

  const [delCategory] = useMutation(DEL_SALES, {
    update(cache, { data: { deleteSales } }) {
      cache.updateQuery(
        {
          query: GET_SALESES,
          variables: {
            first: parseInt(size),
            page: activePage,
            search: "",
            ordered_by: [
              {
                column: "CREATED_AT",
                order: "DESC",
              },
            ],
          },
        },
        (data) => {
          if (data.getSales.data.length === 1) {
            setTotal(total - 1);
            setActivePage(activePage - 1);
          } else {
            return {
              getSales: {
                data: [
                  ...data.getSales.data.filter(
                    (category) => category.id !== deleteSales.id,
                  ),
                ],
              },
            };
          }
        },
      );
    },
  });

  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const deleteCategory = () => {
    delCategory({
      variables: { id: deleteID },

      onCompleted(data) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Category Deleted Successfully",
        });
      },
      onError(error) {
        setOpenedDelete(false);
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to delete Category ",
        });
      },
    });
  };

  const handleEditSales = (id) => {
    setEditId(id);
    setOpenedEdit(true);
  };

  useEffect(() => {
    setHasMounted(true);
  }, []);
  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };
  useEffect(() => {
    if (data) {
      setTotal(data.getSales.paginatorInfo.lastPage);
    }
  }, [data, size]);
  useEffect(() => {
    refetch();
  }, []);
  const handleChange = (currentPage) => {
    fetchMore({
      variables: {
        first: parseInt(size),
        page: currentPage,
      },
    });
    setActivePage(currentPage);
  };
  if (!hasMounted) {
    return null;
  }
  const handleManageSales = (id) => {
    setEditId(id);
    setOpenedDetail(true);
  };
  const handleAddPrice = (id) => {
    setEditId(id);
    setOpenedAssign(true);
  };
  const handleStatus = (id, status) => {
    setStatusChange(true);
    setDeleteID(id);
    setStatus(status);
  };
  const headerData = [
    {
      label: "Name",
      key: "name_user",
      sortable: true,
      searchable: false,
      width: "10%",
      render: (rowData) => {
        return <span>{rowData.user?.name}</span>;
      },
    },
    {
      label: "Phone",
      key: "phone",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.user.phone}</span>;
      },
    },
    {
      label: "Email",
      key: "email",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.user.email}</span>;
      },
    },

    {
      label: "Region",
      key: "region",
      width: "10%",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.region.name}</span>;
      },
    },
    {
      label: "Actions",
      key: "actions",
      sortable: false,
      searchable: false,
      width: "34%",
      render: (rowData) => {
        return (
          <div style={{ display: "flex", gap: "6px" }}>
            <ActionButton
              label="Assign Warehouse"
              color="assign"
              onClick={() => handleAddPrice(rowData.id)}
            >
              <FiUserPlus fontSize="medium" />{" "}
            </ActionButton>
            <ActionButton label="Edit" onClick={() => handleEditSales(rowData)}>
              <EditIcon style={{ fontSize: "1rem" }} />
            </ActionButton>
            <ActionButton
              label="View"
              color="success"
              onClick={() => handleManageSales(rowData)}
            >
              <FiEye fontSize="medium" />
            </ActionButton>
            {/*
            <Controls.ActionButton
              color="primary"
              title="Delete"
              onClick={() => handleDelete(`${rowData.id}`)}
            >
              <Trash size={17} />
            </Controls.ActionButton>
           */}
            <ActionButton
              label={
                rowData.user.status === "ACTIVE" ? "Deactivate" : "Activate"
              }
              color={
                rowData.user.status === "ACTIVE" ? "deactivate" : "activate"
              }
              onClick={() =>
                handleStatus(
                  rowData.user.id,
                  rowData.user.status === "ACTIVE" ? "SUSPENDED" : "ACTIVE",
                )
              }
            >
              {rowData.user.status === "ACTIVE" ? (
                <PersonOffIcon size={15} />
              ) : (
                <HowToRegIcon size={15} />
              )}
            </ActionButton>
          </div>
        );
      },
    },
  ];

  const optionsData = {
    actionLabel: "Add Sales",
    setAddModal: setOpened,
  };

  const handleUserStatusChange = () => {
    changeUserStatus({
      variables: {
        id: deleteID, // Ensure id is an integer
        status: status, // Toggle the status
      },
    });
  };
  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Drawer
        opened={openedEdit}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title="Editing a Sales"
        padding="xl"
        onClose={() => setOpenedEdit(false)}
        position="bottom"
        size="80%"
      >
        <SalesEditModal
          activePage={activePage}
          editRow={editId}
          setOpenedEdit={setOpenedEdit}
        />
      </Drawer>
      <Drawer
        opened={openedAssign}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title="Asisgned Warehouses"
        padding="xl"
        onClose={() => setOpenedAssign(false)}
        position="bottom"
        size="80%"
      >
        <SalesWarehouseModal
          activePage={activePage}
          id={editId}
          setOpenedEdit={setOpenedEdit}
        />
      </Drawer>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        title="Adding Sales"
        padding="xl"
        size="80%"
        position="bottom"
      >
        <SalesAddModal
          total={total}
          setTotal={setTotal}
          activePage={activePage}
          sisze={size}
          setActivePage={setActivePage}
          setOpened={setOpened}
        />
      </Drawer>
      <Modal
        opened={openedStatusChange}
        onClose={() => setStatusChange(false)}
        title="Warning"
        centered
      >
        <p>{`Are you sure do you want to ${
          status === "ACTIVE" ? "Activate" : "Deactivate"
        } this  user?`}</p>
        <Group position="right">
          <Button onClick={() => handleUserStatusChange()} color="red">
            {status === "ACTIVE" ? "Activate" : "Deactivate"}
          </Button>
        </Group>
      </Modal>
      <Drawer
        opened={openedDetail}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title={
          <Text>
            Sales Detail,{" "}
            <Text
              style={{
                color: "#FF6A00",
              }}
              span
              fw={600}
            >
              {editId?.user?.name}
            </Text>
          </Text>
        }
        padding="xl"
        onClose={() => setOpenedDetail(false)}
        position="bottom"
        size="80%"
      >
        <SalesDetailModal sales={editId} />
      </Drawer>

      <Modal
        opened={openedDelete}
        onClose={() => setOpenedDelete(false)}
        title="Warning"
        centered
      >
        <p>Are you sure do you want todelete this sales?</p>
        <Group position="right">
          <Button onClick={() => deleteCategory()} color="red">
            Delete
          </Button>
        </Group>
      </Modal>

      <Card shadow="sm" p="lg">
        <ScrollArea>
          <B2bTable
            total={total}
            activePage={activePage}
            clearInput={clearInput}
            handelSearch={handleManualSearch}
            searchValue={confirmedSearch}
            paginatorInfo={data.getSales.paginatorInfo}
            onSearchChange={setConfirmedSearch}
            handleChange={handleChange}
            header={headerData}
            optionsData={optionsData}
            loading={loading}
            data={data ? data.getSales.data : []}
            handlePageSizeChange={handlePageSizeChange}
            size={size}
          />
        </ScrollArea>
      </Card>
    </div>
  );
};

export default Sales;
